import React from 'react'
import { Desc, Head2, Head3 } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'

export const Accuracy: React.FC = () => {
  return (
    <>
      <Head2
        textColor={colors.gray.gray20}
      >{`Two Rounds. Four Unleashed All-Starts & Five PLL All-Stars`}</Head2>
      <Head3
        textColor={colors.gray.gray20}
      >{`3 Moneyballs worth two points are available.`}</Head3>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`Round 1: 4 Unleashed All-Stars followed by 5 PLL All-Stars`}</Desc>
        </li>
        <li>
          <Desc
            textColor={colors.gray.gray20}
          >{`Round 2: 1 PLL All-Star facing 1 Unleashed All-Star
          `}</Desc>
        </li>
      </ul>

      <Head2 textColor={colors.gray.gray20}>{`Former Winners`}</Head2>
      <ul>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2023: Logan Wisnauskas`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2022: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2021: Marcus Holman`}</Desc>
        </li>
        <li>
          <Desc textColor={colors.gray.gray20}>{`2019: Marcus Holman`}</Desc>
        </li>
      </ul>
    </>
  )
}
